/**
 * 公共接口
 * */
export default [
  {
    /**
     * 生成图片验证码
     * http://10.222.95.129/#/view/Br2jVn2G
     */
    name: 'verifyCodeImgGenerate',
    method: 'post',
    url: '/page/imageVerifyCode/noAuth/imageVerifyCodeGenerate',
  },
  {
    /**
     * 查询菜单与产品类型
     *
     * http://mock.jdfmgt.com/interface/detail?projectId=61a08f6195840a42e010a1e4&interfaceId=62739f8f7a82f9036757c1c3
     */
    name: 'getProductMenus',
    method: 'post',
    url: '/finhub/finhub/userProduct/getProductMenus',
  },
  {
    /**
     * 公共字典接口
     */
    name: 'queryDictList',
    method: 'post',
    url: '/page/dictionary/itemslist',
  },
  // 获取公司信息
  // https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=62f9ffc8855696ad35fc3dde
  {
    name: 'queryCompanyInfo',
    method: 'post',
    url: '/finhub/front/potentialCustomer/queryCompanyInfo',
  },
  // 获取公司信息详情
  // https://http.jd.com/interface/detail?projectId=62f5c111855696ad35fc3d4d&interfaceId=630db86bf54b57a735200863
  {
    name: 'queryUserCompanyDetail',
    method: 'post',
    url: '/finhub/front/potentialCustomer/queryUserCompanyDetail',
  },
  {
    /**
     * 查询菜单与产品类型
     *
     * http://mock.jdfmgt.com/interface/detail?projectId=61a08f6195840a42e010a1e4&interfaceId=62739f8f7a82f9036757c1c3
     */
    name: 'getProductMenus',
    method: 'post',
    url: '/finhub/front/product/getProductMenus',
  },
]
